import { render, staticRenderFns } from "./GlobalHeaderCustomizations.vue?vue&type=template&id=711bd953&"
import script from "./GlobalHeaderCustomizations.vue?vue&type=script&lang=js&"
export * from "./GlobalHeaderCustomizations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports